module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('ul', [_c('li', [_c('router-link', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "to": "/center"
    }
  }, [_vm._v("center")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "to": "/corner"
    }
  }, [_vm._v("corner")])], 1)]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.npminstall/vue-loader/10.3.0/vue-loader/lib/template-compiler.js?id=data-v-37045965!./~/.npminstall/vue-loader/10.3.0/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 30
// module chunks = 1